import { isString } from 'lodash';
import Color from 'color';
import { isMergeTagExpression } from '@bay-email/core';

function normalizeColorValue(val: string) {
	const trimmedValue = val.toString().trim();

	if (!trimmedValue) return '';
	if (trimmedValue.toLowerCase() === 'transparent') return 'Transparent';
	// A dynamic merge tag (e.g. "{{user.brandPrimaryColor}}") is not a literal colour —
	// pass it through untouched so Color() doesn't mangle it.
	if (isMergeTagExpression(trimmedValue)) return trimmedValue;

	try {
		if (trimmedValue.length === 6 && Color(`#${trimmedValue}`).hex())
			return Color(`#${trimmedValue}`).hex();
		return Color(trimmedValue).hex();
	} catch {
		return trimmedValue;
	}
}

export const colorAdapter = {
	format(val: string) {
		if (!isString(val) && !val) return '';
		return normalizeColorValue(val);
	},
	parse(val: string) {
		if (!isString(val)) return undefined;
		const normalizedValue = normalizeColorValue(val);
		return normalizedValue || undefined;
	},
};
